var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rulespage"},[_vm._v(" Rules wil go here, but I haven't done this work yet. ")])}
var staticRenderFns = []

export { render, staticRenderFns }